export default __webpack_public_path__ + "static/media/184.754eea3f.jpg";